export default function SongLoadAction(actionContext, payload, callback) {
    actionContext.dispatch('SONG_LOAD', payload.songData);
    callback(null, payload.songData);
}
